import createAxiosInstance from "../utils/axiosInstance";
import Env from "../env/Env";

const request = createAxiosInstance(`${Env.API_BASE}/api/internal/database`);

export interface DatabaseQueryRow {
  id: number;
  user: string;
  host: string;
  db: string | null;
  command: string;
  timeSec: number;
  state: string | null;
  info: string | null;
  killable: boolean;
  stuck: boolean;
}

export interface DatabaseStatusResponse {
  success: boolean;
  tenantId: string;
  stuckThresholdSec: number;
  stuckCount: number;
  pool: {
    configured: {
      min: number;
      max: number;
      acquireTimeoutMs: number;
      connectTimeoutMs: number;
      queryTimeoutMs: number;
    };
    used: number;
    free: number;
    pendingAcquires: number;
    pendingCreates: number;
    size: number;
  };
  server: {
    threadsConnected: number;
    threadsRunning: number;
    maxUsedConnections: number;
    slowQueries: number;
    uptimeSec: number;
    connections: number;
    abortedConnects: number;
    maxConnections: number;
    innodbBufferPoolSize: number;
    version: string;
  };
  queries: DatabaseQueryRow[];
}

const databaseAPIsService = {
  getStatus: (signal?: AbortSignal): Promise<DatabaseStatusResponse> => {
    return new Promise((resolve, reject) => {
      request
        .get("/", { signal })
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },

  killConnection: (connectionId: number): Promise<{ success: boolean; message?: string; connectionId?: number }> => {
    return new Promise((resolve, reject) => {
      request
        .post(`/kill/${encodeURIComponent(String(connectionId))}`)
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },

  killAllStuck: (): Promise<{
    success: boolean;
    message?: string;
    killed?: number[];
    stuckThresholdSec?: number;
    warnings?: string[];
  }> => {
    return new Promise((resolve, reject) => {
      request
        .post("/kill-all")
        .then(({ data }) => resolve(data))
        .catch((err) => reject(err?.response?.data || err));
    });
  },
};

export default databaseAPIsService;
